import styled from '@emotion/styled';

const Layout = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  position: absolute;
  align-items: center;
  will-change: transform;
  justify-content: center;
`;

export default Layout;